export const AUTOMATION_STATUS = {
    ACTIVE: "ACTIVE",
    INACTIVE: "INACTIVE",
};

export const AUTOMATION_ACTION_TYPE = {
    CLOSE_TICKET: "CLOSE_TICKET",
    SEND_MESSAGE: "SEND_MESSAGE",
};

export const AUTOMATION_ACTION_LABELS = {
    CLOSE_TICKET: "Close Ticket",
    SEND_MESSAGE: "Send a Message",
};

export const AUTOMATION_CONDITION_FIELD = {
    TICKET_STATUS: "TICKET_STATUS",
    HOURS_SINCE_STATUS: "HOURS_SINCE_STATUS",
    HOURS_SINCE_LAST_ACTIVITY: "HOURS_SINCE_LAST_ACTIVITY",
    TICKET_PHASE: "TICKET_PHASE",
    TICKET_SOURCE: "TICKET_SOURCE",
    NO_AGENT_REPLY: "NO_AGENT_REPLY",
};

export const AUTOMATION_CONDITION_FIELD_LABELS = {
    TICKET_STATUS: "Ticket status",
    HOURS_SINCE_STATUS: "Hours since ticket status",
    HOURS_SINCE_LAST_ACTIVITY: "Hours since last activity",
    TICKET_PHASE: "Ticket phase",
    TICKET_SOURCE: "Ticket source",
    NO_AGENT_REPLY: "No agent reply yet",
};

export const AUTOMATION_OPERATOR = {
    IS: "IS",
    IS_NOT: "IS_NOT",
    GREATER_THAN: "GREATER_THAN",
    LESS_THAN: "LESS_THAN",
};

export const AUTOMATION_OPERATOR_LABELS = {
    IS: "is",
    IS_NOT: "is not",
    GREATER_THAN: "greater than",
    LESS_THAN: "less than",
};

export const TICKET_STATUS_VALUES = {
    WAITING_FOR_CUSTOMER: "WAITING_FOR_CUSTOMER",
    OPEN: "OPEN",
};

export const TICKET_STATUS_LABELS = {
    WAITING_FOR_CUSTOMER: "Waiting for customer resp",
    OPEN: "Open",
};

export const TEMPLATE_VARIABLES = ['{{customer.first_name}}'];

export const AUTOMATION_TABLE_HEADERS = [
    "Automation",
    "Status",
    "Action",
    "Created",
    "Updated",
    "",
];

export const AUTOMATION_ACTIONS = {
    EDIT_AUTOMATION: "EDIT_AUTOMATION",
    DELETE_AUTOMATION: "DELETE_AUTOMATION",
};

export const CONDITION_FIELD_OPTIONS = Object.keys(
    AUTOMATION_CONDITION_FIELD_LABELS
).map((key) => ({
    label: AUTOMATION_CONDITION_FIELD_LABELS[key],
    value: key,
}));

export const OPERATOR_OPTIONS = Object.keys(AUTOMATION_OPERATOR_LABELS).map(
    (key) => ({
        label: AUTOMATION_OPERATOR_LABELS[key],
        value: key,
    })
);

export const ACTION_OPTIONS = Object.keys(AUTOMATION_ACTION_LABELS).map(
    (key) => ({
        label: AUTOMATION_ACTION_LABELS[key],
        value: key,
    })
);

export const TICKET_STATUS_OPTIONS = Object.keys(TICKET_STATUS_LABELS).map(
    (key) => ({
        label: TICKET_STATUS_LABELS[key],
        value: key,
    })
);

export const PHASE_OPTIONS = [
    { label: "Issue discovery", value: "ISSUE_DISCOVERY" },
    { label: "Problem confirmation", value: "PROBLEM_CONFIRMATION" },
    { label: "Solution delivery", value: "SOLUTION_DELIVERY" },
];

export const TICKET_PHASE_LABELS = PHASE_OPTIONS.reduce((acc, item) => {
    acc[item.value] = item.label;
    return acc;
}, {});

export const SOURCE_OPTIONS = [
    { label: "In-app", value: "IN_APP" },
    { label: "Email", value: "EMAIL" },
    { label: "Twitter", value: "TWITTER" },
    { label: "Facebook Messenger", value: "FACEBOOK_MESSENGER" },
    { label: "Instagram", value: "INSTAGRAM" },
];

export const defaultCondition = () => ({
    field: AUTOMATION_CONDITION_FIELD.TICKET_STATUS,
    operator: AUTOMATION_OPERATOR.IS,
    value: TICKET_STATUS_VALUES.WAITING_FOR_CUSTOMER,
});

export const emptyAutomationForm = () => ({
    name: "",
    matchAllConditions: [defaultCondition()],
    matchAnyConditions: [],
    actionType: AUTOMATION_ACTION_TYPE.CLOSE_TICKET,
    actionPayload: {
        messageTemplate: "",
        notifyCustomer: true,
    },
    status: AUTOMATION_STATUS.INACTIVE,
});
